module.exports = __webpack_public_path__ + "img/tempo.9d62ee13.png";